import React from "react";

export function StatusBadge({ status }) {
  const map = {
    pending: "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20",
    approved: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20",
    rejected: "bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20",
    draft: "bg-muted text-muted-foreground border-border",
    healthy: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20",
    low: "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20",
    out: "bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20",
  };
  const cls = map[status] || "bg-muted text-muted-foreground border-border";
  return (
    <span
      data-testid={`status-${status}`}
      className={`inline-flex items-center gap-1 border ${cls} px-2.5 py-0.5 rounded-full text-xs font-medium capitalize`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-80" />
      {status}
    </span>
  );
}
